const FullScreenLoader = () => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="w-full md:w-1/2 flex flex-col gap-4 items-center justify-center bg-[#E71A22] p-6 m-12 border-2 border-white rounded-2xl shadow-lg font-bold">
        <svg
          className="animate-spin h-12 w-12 text-white z-30"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          ></path>
        </svg>
        <span className="text-white">ĐANG GỬI...</span>
      </div>
    </div>
  );
};

export default FullScreenLoader;
